import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import GlobalSearchResultsRenderer from './global_search_results_renderer';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../constants';
import UploadingOverlay from '../../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import * as tracking from '../../tracking';
class GlobalSearch extends Component {
	constructor(props) {
		super(props);
		this.typingTimer = null;
		this.state = {
			inputValue: '',
			taskResultsCount: null,
			value: '',
			expanded: false,
			resultCategoryExpandedMap: new Map([
				['tasks', true],
				['projects', true],
				['team_members', true],
			]),
			selectedResultsCategoryIndex: null,
			selectedResultIndex: null,
			selectedAdvancedSearchOption: false,
			imitateClickAtSelectedIndex: false,
			forceFetch: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.forceFetch && !prevState.forceFetch) {
			this.setState({forceFetch: false});
		}

		if (prevState.taskResultsCount !== this.state.taskResultsCount) {
			const count = this.state.taskResultsCount;
			const searchString = this.state.inputValue;

			tracking.trackEvent('Global Search Results', {searchString: searchString, matching: count});
		}
	}
	toggleResultCategoryExpand(resultCategory, e) {
		if (e) {
			e.preventDefault();
		}
		const resultCategoryExpandedMap = new Map(this.state.resultCategoryExpandedMap);
		resultCategoryExpandedMap.set(resultCategory.value, !this.state.resultCategoryExpandedMap.get(resultCategory.value));
		this.setState({resultCategoryExpandedMap});
	}
	updateTaskSearchResultsCount(count) {
		if (count !== this.state.taskSearchResultsCount) {
			this.setState({
				taskResultsCount: count,
				selectedResultsCategoryIndex: null,
				selectedResultIndex: null,
				selectedAdvancedSearchOption: false,
			});
		}
	}
	showTaskModal(companyTaskId) {
		tracking.trackElementClicked('GlobalSearch-Open-Task');
		this.close();
		this.props.showTaskModal(companyTaskId);
	}
	onSearchChange(e) {
		this.setState({inputValue: e.target.value});
	}
	onInputFocus() {
		tracking.trackElementClicked('GlobalSearch');
		this.setState({expanded: true});
	}
	onInputBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (
			newTarget &&
			(newTarget.id === 'global-search-clear-icon' ||
				newTarget.id === 'global-search-results-dropdown-category-option' ||
				newTarget.id === 'result-category-option-expand-button' ||
				newTarget.id === 'advanced-search-option')
		) {
			return;
		}
		this.close(true);
	}
	clearCountdown() {
		if (this.typingTimer !== null) {
			clearTimeout(this.typingTimer);
		}
	}
	startCountdown() {
		this.clearCountdown();
		this.typingTimer = setTimeout(this.doneTyping.bind(this), 500);
	}
	doneTyping() {
		this.setState({value: this.state.inputValue, forceFetch: true});
	}
	close(fromInputBlur) {
		if (!fromInputBlur && this.global_search_input) {
			this.global_search_input.blur();
		}
		this.setState({
			expanded: false,
			inputValue: '',
			value: '',
			selectedAdvancedSearchOption: false,
			selectedResultsCategoryIndex: null,
			selectedResultIndex: null,
			imitateClickAtSelectedIndex: false,
		});
	}
	onCloseButtonClick() {
		this.setState({inputValue: '', value: ''});
		if (this.global_search_input) {
			this.global_search_input.focus();
		}
	}

	seeAllTaskResults() {
		const value = this.state.value || '';
		this.close();
		tracking.trackElementClicked('GlobalSearch-See-All-Tasks');
		this.props.history.push({
			pathname: '/global-search',
			state: {
				searchQuery: value,
			},
		});
	}

	//use to mark option as selected on hover
	selectOptionAtIndex(selectedResultsCategoryIndex, selectedResultIndex) {
		if (
			this.state.selectedResultIndex !== selectedResultIndex ||
			this.state.selectedResultsCategoryIndex !== selectedResultsCategoryIndex
		) {
			this.setState({selectedResultsCategoryIndex, selectedResultIndex});
		}
	}

	//dont mark as selected when mouse leaves selected option
	deselectOptionsAtIndex() {
		this.setState({selectedResultsCategoryIndex: null, selectedResultIndex: null});
	}

	onKeyDown(e) {
		this.clearCountdown();
		if (e.keyCode === 40) {
			//arrow down
			if (
				this.state.expanded &&
				!this.state.selectedAdvancedSearchOption &&
				(this.state.value === null || this.state.value === undefined || this.state.value === '')
			) {
				this.setState({
					selectedAdvancedSearchOption: true,
					selectedResultsCategoryIndex: null,
					selectedResultIndex: null,
					imitateClickAtSelectedIndex: false,
				});
			} else if (this.state.expanded && this.state.value) {
				let {selectedResultIndex, selectedResultsCategoryIndex} = this.state;
				if (selectedResultsCategoryIndex === null && selectedResultIndex === null) {
					selectedResultsCategoryIndex = 0;
				} else if (selectedResultsCategoryIndex === 0) {
					if (
						this.state.resultCategoryExpandedMap.get('tasks') &&
						(this.state.taskResultsCount - 1 > selectedResultIndex ||
							(this.state.taskSearchResultsCount !== 0 && selectedResultIndex === null))
					) {
						//tasks category expanded and has at least one result
						if (selectedResultIndex === null) {
							selectedResultIndex = 0;
						} else if (this.state.taskResultsCount - 1 > selectedResultIndex && selectedResultIndex < 4) {
							//we show max 5 results in dropdown. Dont increase index if selected fifth option
							selectedResultIndex++;
						} else if (selectedResultIndex === 4 || this.state.taskResultsCount - 1 === selectedResultIndex) {
							//select see all option if here. If we add more categories in the future this needs to select next category
							selectedResultIndex = 0;
							selectedResultsCategoryIndex = null;
						}
					} else if (this.state.taskResultsCount > 5) {
						//for now we only have tasks in categories so once last option is selected and down arrow is pressed select see all results option.
						//In the future we need to select next category if this line is reached
						selectedResultIndex = 0;
						selectedResultsCategoryIndex = null;
					}
				}
				//right now selectedResultsCategoryIndex can only be 0 or null. In the future when we add more categories this needs to be extended
				if (
					this.state.selectedResultIndex !== selectedResultIndex ||
					selectedResultsCategoryIndex !== this.state.selectedResultsCategoryIndex
				) {
					this.setState({selectedResultIndex, selectedResultsCategoryIndex, selectedAdvancedSearchOption: false});
				}
			}
		} else if (e.keyCode === 38) {
			//arrow up
			if (this.state.expanded && !this.state.value && this.state.selectedAdvancedSearchOption) {
				this.setState({selectedAdvancedSearchOption: false});
			} else if (this.state.expanded && this.state.value) {
				let {selectedResultIndex, selectedResultsCategoryIndex} = this.state;
				if (selectedResultsCategoryIndex !== null) {
					if (selectedResultIndex === null) {
						//up arrow while category option selected
						if (selectedResultsCategoryIndex === 0) {
							selectedResultsCategoryIndex = null;
						} else {
							selectedResultsCategoryIndex--;
						}
					} else {
						if (selectedResultIndex === 0) {
							selectedResultIndex = null;
						} else {
							selectedResultIndex--;
						}
					}
				} else if (selectedResultsCategoryIndex === null && selectedResultIndex === 0) {
					//see all results option is currently marked. select last option of last category which is tasks for now
					selectedResultsCategoryIndex = 0;
					//check if expanded
					if (this.state.resultCategoryExpandedMap.get('tasks')) {
						if (this.state.taskResultsCount > 5) {
							selectedResultIndex = 4;
						} else {
							selectedResultIndex = this.state.taskResultsCount - 1;
						}
					} else {
						selectedResultIndex = null;
					}
				}
				if (
					selectedResultIndex !== this.state.selectedResultIndex ||
					selectedResultsCategoryIndex !== this.state.selectedResultsCategoryIndex
				) {
					this.setState({selectedResultIndex, selectedResultsCategoryIndex});
				}
			}
		} else if (e.keyCode === 27) {
			//escape
			// close dropdown and input
			this.close();
		} else if (e.keyCode === 13 || e.keyCode === 32) {
			//enter or space
			// select  if over a clickable opton
			if (this.state.selectedAdvancedSearchOption) {
				this.seeAllTaskResults();
			} else if (this.state.selectedResultsCategoryIndex !== null) {
				if (this.state.selectedResultIndex === null) {
					this.toggleResultCategoryExpand({value: 'tasks'});
				} else {
					this.setState({imitateClickAtSelectedIndex: true});
				}
			} else if (this.state.selectedResultsCategoryIndex === null && this.state.selectedResultIndex === 0) {
				//see all option
				this.seeAllTaskResults();
			}
		}
	}

	render() {
		const searchQuery = {
			filters: [{field: GLOBAL_FILTER_FIELD.NAME, operator: GLOBAL_FILTER_OPERATOR.CONTAINS, value: this.state.value}],
		};
		return (
			<div className="global-search-component">
				<input
					id="global-search-input"
					className={
						'global-search-input' +
						(this.state.expanded ? ' focused' : '') +
						(this.state.expanded && this.state.value !== '' ? ' search-results-expanded' : '')
					}
					value={this.state.expanded ? this.state.inputValue : ''}
					onChange={this.onSearchChange.bind(this)}
					autoComplete={'off'}
					onFocus={this.onInputFocus.bind(this)}
					onBlur={this.onInputBlur.bind(this)}
					onKeyDown={this.onKeyDown.bind(this)}
					onKeyUp={this.startCountdown.bind(this)}
					ref={input => (this.global_search_input = input)}
					placeholder={this.state.expanded ? this.props.intl.formatMessage({id: 'global_search.placeholder'}) : ''}
				/>
				<div
					id="global-search-clear-icon"
					className={'global-search-clear-icon' + (this.state.expanded ? ' visible' : '')}
					onClick={this.onCloseButtonClick.bind(this)}
					tabIndex="0"
				/>
				{this.state.expanded ? (
					this.state.value && this.state.inputValue === this.state.value ? (
						<GlobalSearchResultsRenderer
							searchQuery={searchQuery}
							expanded={this.state.expanded}
							showTaskModal={this.showTaskModal.bind(this)}
							close={this.close.bind(this)}
							seeAllTaskResults={this.seeAllTaskResults.bind(this)}
							selectedResultsCategoryIndex={this.state.selectedResultsCategoryIndex}
							selectedResultIndex={this.state.selectedResultIndex}
							updateTaskSearchResultsCount={this.updateTaskSearchResultsCount.bind(this)}
							taskResultsCount={this.state.taskResultsCount}
							resultCategoryExpandedMap={this.state.resultCategoryExpandedMap}
							toggleResultCategoryExpand={this.toggleResultCategoryExpand.bind(this)}
							imitateClickAtSelectedIndex={this.state.imitateClickAtSelectedIndex}
							selectOptionAtIndex={this.selectOptionAtIndex.bind(this)}
							deselectOptionsAtIndex={this.deselectOptionsAtIndex.bind(this)}
							forceFetch={this.state.forceFetch}
						/>
					) : this.state.inputValue ? (
						<ul className="global-search-results-dropdown expanded">
							<CustomScrollDiv
								autoHeight={true}
								autoHeightMin={1}
								autoHeightMax={444}
								ref={div => (this.customScrollRef = div)}
							>
								<div className="global-search-results-loader-wrapper">
									<UploadingOverlay />
								</div>
							</CustomScrollDiv>
						</ul>
					) : (
						<button
							id="advanced-search-option"
							className={
								'advanced-filtering-option' + (this.state.selectedAdvancedSearchOption ? ' selected' : '')
							}
							onClick={this.seeAllTaskResults.bind(this)}
						>
							{this.props.intl.formatMessage({id: 'global_filter_advanced_search_button'})}
						</button>
					)
				) : null}
			</div>
		);
	}
}
export default injectIntl(withRouter(GlobalSearch));
